module.exports = __webpack_public_path__ + "media/images/category/dummy/shoes03-c9698cf38f6b1a0bc0ed53fe393cd823.jpg";